export default {
  add_rate: 'Ajouter un taux',
  remove_rate: 'Supprimer le taux',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Tout mode de paiement',
    card: 'Carte',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'Prélèvement SEPA',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Prélèvement Bacs',
    stripe_other: 'Autres moyens Stripe',
  },
  fields: {
    percentage: 'Pourcentage',
    fixed: 'Montant fixe',
    min: 'Montant minimum',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Rien n’est facturé sur {{method}} pour l’instant : ces paiements génèrent une marge de 0 % tant qu’aucun taux n’est défini.',
    floor_only:
      'Sur {{method}}, les frais de traitement sont de {{floor}} sur chaque paiement, quel que soit le total de la commande.',
    percentage: 'Sur {{method}}, les frais de traitement sont de {{percentage}} % du total de la commande.',
    percentage_floor:
      'Sur {{method}}, les frais de traitement sont de {{percentage}} % du total de la commande, avec un minimum de {{floor}}.',
    fixed: 'Sur {{method}}, les frais de traitement sont de {{fixed}} par paiement.',
    fixed_floor:
      'Sur {{method}}, les frais de traitement sont de {{fixed}} par paiement, avec un minimum de {{floor}}.',
    combined:
      'Sur {{method}}, les frais de traitement sont de {{fixed}} fixes plus {{percentage}} % du total de la commande.',
    combined_floor:
      'Sur {{method}}, les frais de traitement sont de {{fixed}} fixes plus {{percentage}} % du total de la commande, avec un minimum de {{floor}}.',
    redundant_floor:
      'Le minimum de {{floor}} ne s’applique jamais : le montant fixe l’atteint déjà sur chaque paiement. Définissez-le au-dessus de {{fixed}} ou supprimez-le.',
  },
  example: 'Exemple : sur une commande de {{total}}, les frais de traitement sont de {{fee}}.',
};
